<template>
  <div>
    <v-dialog persistent v-model="open" max-width="800px" scrollable>
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">Importar invitados</span>
        </v-card-title>
        <v-card-text >
          <p>
            Importa tu archivo Excel con la lista de invitados como se muestra en el ejemplo. 
            <a href="examples/invitados_externos.xlsx"> Descargar </a>
          </p>
          <v-layout row wrap justify-center>
            <v-flex xs12 class="form-csv text-xs-center" style="height: 30vh; max-height: 350px;">
              <input @change="fileLoad($event)" id="visit_import_file" type="file" accept=".xlsx" />
              <div class="csv-text">
                <h4 class="center-align">Arrastra tu archivo Excel aquí</h4>
                <h5 id="csv-success">
                  O
                  <u style="color: red">
                    <span style="color: red">selecciona</span>
                  </u>
                  el archivo
                </h5>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="close" flat>Cancelar</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <error v-model="toast.failed" :text="toast.eMessage" />
  </div>
</template>

<script>
import error from "../../Dialogs/Error.vue"

const VALID_HEADERS = ["Nombre","Apellidos","Correo"];

export default {
  props: ["open"],
  components: {
    error,
  },
  data: () => ({
    toast: {
      success: false,
      failed: false,
      eMessage: "",
    },
  }),
  methods: {
    close() {
      this.$emit("close")
    },
    fileLoad(event) {
      // this.working.loading = true;
      var files = event.target.files;

      if (files.length > 0) {
        var file = files[0];
        var excel2json;
        var allowedExtensions = /.xlsx$/i;
        
        if(allowedExtensions.exec(event.target.value)) {

          if (typeof require !== 'undefined')
            var XLSX = require('xlsx');

          var rdr = new FileReader();
          var self = this;

          rdr.onload = function () {
            var data = new Uint8Array(rdr.result);
            var arr = new Array();

            for (var i = 0; i != data.length; ++i)
              arr[i] = String.fromCharCode(data[i]);

            var bstr = arr.join("");

            // Call XLSX 
            var workbook = XLSX.read(bstr, {
              type: "binary"
            });
            
            // DO SOMETHING WITH workbook HERE 
            var first_sheet_name = workbook.SheetNames[0];
            // Get worksheet
            var worksheet = workbook.Sheets[first_sheet_name];

            //Get "Headers", first row from first sheet
            var headerRegex = new RegExp('^([A-Za-z]+)1=\'(.*)$');
            var cells = XLSX.utils.sheet_to_formulae(worksheet);
            var fileHeaders = cells.filter(item => headerRegex.test(item)).map(item => item.split("='")[1]);
            
            excel2json = XLSX.utils.sheet_to_json(worksheet, {
              raw: true
            });
            
            //Verify headers
            let validHeaders = VALID_HEADERS.every(h => fileHeaders.includes(h));

            if(validHeaders) {
            // this.working.loading = true;
            console.log(excel2json)
            
            var visitants = excel2json.map(v => ({
              firstName: v.Nombre ,
              lastName: v.Apellidos ,
              email: v.Correo || ""
            }))
            self.$emit("importVisitans",visitants)
            } else {
            // this.working.loading = true;
            console.log("formato invalido")
            self.toast.eMessage = "formato invalido";
            self.toast.failed = true;
            }
            
            event.target.value = null;
          }

          rdr.readAsArrayBuffer(file);

        }

      }
      else  {
        console.log("no es xlsx");
      }
      
    },
  }
}
</script>